import {GraphQLErrors} from '@apollo/client/errors';
import {entries, keys} from 'src/types/general';

export function processValidationErrors(
    errors: GraphQLErrors,
    values: Record<string, any>,
    setFieldError: (field: string, errors: string[]) => any,
    map?: Record<string, string>,
) {
    const validationErrors = errors.filter((error) => error.extensions.category === 'arguments_validation_error');
    const graphqlToFormik: Record<string, string> = {};
    if (map) {
        entries(map).forEach(([key, value]) => {
            graphqlToFormik[value] = key;
        });
    } else {
        keys(values).forEach(key => {
            graphqlToFormik[key] = key;
        });
    }

    let errorMessages: Record<string, any> = {};

    for (const validationError of validationErrors) {
        const errors = Object.entries(validationError.extensions.validation);
        const fields = Object.keys(values);

        errorMessages = errors.reduce((carry, [name, fieldErrors]: [string, any]) => {
            const fieldName = graphqlToFormik[name.split('.').slice(-1)[0]];

            if (fields.includes(fieldName)) {
                if (!carry.hasOwnProperty(fieldName)) {
                    carry[fieldName] = [];
                }
                carry[fieldName].push(...fieldErrors.map((e: {message: string}) => e.message));
            }
            return carry;
        }, errorMessages);
    }

    entries(errorMessages).map(([field, errors]) => {
        setFieldError(field, errors);
    });

    return;
}
